export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ14.04bbffb7.mp3";